//////////////////
// Header Controller
// ------------
// Simple wrapper for the header to aid with height management due to absolute positioned elements
//////////////////
App.Header = (function() {

	// Variables
	var siteHeader, heroImage, headerFauxHeight;
	var selectors = {
		siteHeader: ".site-header:not(.type-investment)",
		heros: ".hero"
	};

	/*
	Add click handlers to navigation
	*/
	function addHeaderHeightHandler() {
		try {
			siteHeader = $(selectors.siteHeader);
			heroes = siteHeader.find(selectors.heros);

			// Only execute if there is a image in the header as they cause the issues
			if(heroes.length) {
				$(window).on("resize", setAssetSize);
				setAssetSize();
			}
		} catch(e) {
			console.log("Couldn't add " + selectors.siteHeader, e);
		}
	}

	/*
	Set size of figures based on actual image size
	- This allows us to control the header size and position via class
	- versus having to wait for load events
	*/
	function setAssetSize() {

		heroes.each(function(i, el) {
			var fig = $(el);
			var img = fig.children("img, video");
			var ratio = img.attr("data-height") / img.attr("data-width");
			var height =
				// Set the height based on a ratio of the rendered width
				fig.children().first().width() * ratio;

			var marginTop = Number(fig.css("marginTop").split("px")[0]);
			if(marginTop < 0) {
				// Adjust for negative margins
				// height += Math.abs(marginTop);
			}
			fig.attr("style", "height:" + height.toFixed(3) + "px;");
		});
	}

	App.register(function() {
		App.log("Registered: App.Header");
		addHeaderHeightHandler();
	});

})();
